document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContadores();
  initComparador();
  initMarquesina();
});

function initReveal() {
  const els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach((el) => el.classList.add('mt-visible'));
    return;
  }
  const obs = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const delay = entry.target.dataset.mtDelay || 0;
          setTimeout(() => entry.target.classList.add('mt-visible'), Number(delay));
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach((el) => obs.observe(el));
}

function initContadores() {
  const els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length) return;
  const anima = (el) => {
    const fin = parseFloat(el.dataset.mtContador);
    const decimales = (el.dataset.mtContador.split('.')[1] || '').length;
    const dur = 1400;
    const inicio = performance.now();
    function paso(ahora) {
      const p = Math.min((ahora - inicio) / dur, 1);
      const val = fin * (1 - Math.pow(1 - p, 3));
      el.textContent = val.toFixed(decimales);
      if (p < 1) requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);
  };
  const obs = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        anima(entry.target);
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.6 });
  els.forEach((el) => obs.observe(el));
}

function initComparador() {
  document.querySelectorAll('[data-mt-comparador]').forEach((wrap) => {
    const slider = wrap.querySelector('[data-mt-comparador-slider]');
    const despues = wrap.querySelector('[data-mt-comparador-despues]');
    if (!slider || !despues) return;
    const set = (valor) => {
      despues.style.clipPath = `inset(0 0 0 ${valor}%)`;
    };
    set(slider.value || 50);
    slider.addEventListener('input', (e) => set(e.target.value));
  });
}

function initMarquesina() {
  document.querySelectorAll('[data-mt-marquesina]').forEach((track) => {
    if (track.dataset.mtCloned) return;
    track.dataset.mtCloned = '1';
    track.innerHTML += track.innerHTML;
  });
}
